import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import WebpImage from '../webp-image';
import MoneyUtils from '../../services/MoneyUtils';
import './style.css';

const getPlanImage = (months, minimumMonths) => {
  let imageName = 'subSelectionOptionMonthly';
  if (months === '12' || minimumMonths === 12) {
    imageName = 'subSelectionOption12';
  } else if (months === '9' || minimumMonths === 9) {
    imageName = 'subSelectionOption9';
  } else if (months === '6' || minimumMonths === 6) {
    imageName = 'subSelectionOption6';
  } else if (months === '3') {
    imageName = 'subSelectionOption3';
  }
  return imageName;
};

const getPinkBoxMessage = (props) => {
  if (props.plan.selectSubMessage) return props.plan.selectSubMessage;
  if (props.plan.originalCost !== props.plan.costWithCoupon) {
    if (props.plan.couponToAutoPopulate) {
      if (
        props.plan.couponToAutoPopulate.discountPercentage &&
        props.plan.couponToAutoPopulate.discountPercentage > 0
      ) {
        return `${props.plan.couponToAutoPopulate.discountPercentage}% Off First Box!`;
      }
    }
    return `$${props.plan.costWithCoupon} First Box!`;
  }
  return <span>&nbsp;</span>;
};

const renderSubscriptionTag = (plan) => {
  if (plan.tagType === 'BEST_VALUE') {
    return <div className='subscriptionTag bestvalue'>Best Value</div>;
  }
  if (plan.tagType === 'MOST_POPULAR') {
    return <div className='subscriptionTag mostpopular'>Most Popular</div>;
  }
  return null;
};

const renderCircleTag = (plan) => {
  if (plan.circleMessage) {
    const numberOfWords = plan.circleMessage.split(' ').length;
    const circleClassName = `circleTag${numberOfWords}Words`;
    return (
      <div className={`circleTag ${circleClassName}`}>{plan.circleMessage}</div>
    );
  }
  return null;
};

const SelectSubscription = (props) => {
  if (!props.plan) {
    return null;
  }

  let planClassName = `${props.plan.title}${props.plan.months}`;
  planClassName = planClassName.replace(/\s+/g, '');
  let buttonClassName = `subSelectButton ${planClassName}`;
  if (props.activeIndex === props.planIndex) {
    buttonClassName = `${buttonClassName} subSelectButtonActiveInCarousel`;
  }

  return (
    <Row className='subContainer'>
      <Col>
        {renderSubscriptionTag(props.plan)}
        {renderCircleTag(props.plan)}
        <Row>
          <Col xs={8} sm={8} md={12} lg={12} style={{ margin: '0 auto' }}>
            <WebpImage
              imageName={getPlanImage(
                props.plan.months,
                props.plan.minimumMonths,
              )}
              width='300'
              height='180'
              className='subSelectionImage'
              fluid
              alt={`${props.plan.title} Subscription Plan`}
            />
          </Col>
        </Row>
        {props.plan.provider !== 'bitsy' ? (
          <Row>
            <Col>
              <>
                <h3 className='subTitle'>{props.plan.title} Subscription</h3>
                {props.plan.months === 'INFINITY' ? (
                  <h4 className='subTitle subTitle2'>
                    $
                    {`${MoneyUtils.formatAsMoney(
                      props.plan.originalCost,
                    )}/month`}
                  </h4>
                ) : null}
              </>
            </Col>
          </Row>
        ) : null}
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <hr className='gray-line spaceBelow10' />
          </Col>
        </Row>
        <Row className='subBoxSubContainer'>
          <Col xs={12} sm={12} md={12} lg={12}>
            <Col className='bulletpointContainer'>
              {props.plan && props.plan.highlights
                ? props.plan.highlights
                    .sort((a, b) => a.order - b.order)
                    .map((item, index) => {
                      return (
                        <Row
                          key={props.plan._id + item.text}
                          className={`subBoxSubHeader left-align ${
                            index !== 0 ? 'spaceAbove10' : ''
                          }`}
                        >
                          <Col
                            className={`${item.className}`}
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                          >
                            {' '}
                            {item.text}
                          </Col>
                        </Row>
                      );
                    })
                : null}
            </Col>
            <Row className='spaceAbove10 center-align'>
              <div className='actualCostHeader inline-text'>
                {props.plan.months !== 'INFINITY' ? (
                  <div className='subBoxHeader1 center-align'>
                    <div className='inline-text'>$</div>
                    <div className='inline-text'>{props.plan.originalCost}</div>
                  </div>
                ) : null}
                <div className='inline-text'>$</div>
                <div className='inline-text extremelyBold'>
                  {props.plan.months === 'INFINITY'
                    ? `${MoneyUtils.formatAsMoney(
                        props.plan.costWithCoupon,
                      )} First Box`
                    : props.plan.costWithCoupon}
                </div>
              </div>

              {props.plan.months === 'INFINITY' ? (
                <div
                  className={`inline-text secondary-text first-box-discount ${
                    props.plan.originalCost !== props.plan.costWithCoupon ||
                    props.plan.selectSubMessage
                      ? 'first-box-discount-with-contents'
                      : ''
                  }`}
                >
                  {getPinkBoxMessage(props)}
                </div>
              ) : null}
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <Button
              variant='primary'
              className={buttonClassName}
              onClick={() => props.nextStep(props.plan)}
              aria-label={`Add ${props.plan.title} ${
                props.plan.months === 'INFINITY' ? '' : 'Bundled '
              }Subscription Plan to cart`}
            >
              ADD TO CART
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default SelectSubscription;
